module.exports = __webpack_public_path__ + "static/media/hello-kitty.29f2b149.png";